// extracted by mini-css-extract-plugin
module.exports = {"NotificationWrapper":"NotificationMessage_NotificationWrapper__3368U"};